import { Box, Typography } from "@mui/material";
import { RedocStandalone } from "redoc";
import useColors from "../../../../api/hooks/useColors";
import Header from "../../../../components/Header";
import ApiDocsOverview from "./ApiDocsOverview";

const ApiDocs = () => {
  const colors = useColors();
  const openApiUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/openapi.json`;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: colors.common_white,
        overflow: "auto",
        zIndex: 1300, // Higher than sidebar z-index
      }}
    >
      <Box sx={{ p: 3 }}>
        <Header title="API Documentation" />
        <ApiDocsOverview />

        {/* Redoc Documentation */}
        {openApiUrl ? (
          <RedocStandalone
            specUrl={openApiUrl}
            options={{
              theme: {
                colors: {
                  primary: {
                    main: colors.primary?.[500] || "#1976d2",
                  },
                },
                spacing: {
                  sectionVertical: 20, // Reduces vertical spacing between sections
                  sectionHorizontal: 20,
                },
                typography: {
                  headings: {
                    fontFamily: "inherit",
                  },
                },
              },
              expandResponses: "200,201",
              hideDownloadButton: false,
              hideHostname: false,
              hideLoading: false,
              hideSchemaPattern: false,
              hideRequestPayloadSample: false,
              showExtensions: true,
              sortPropsAlphabetically: true,
              payloadSampleIdx: 0,
              expandSingleSchemaField: true,
              menuToggle: true,
              searchBoxDisabled: false,
              pathInMiddlePanel: false,
              hideOneOfDescription: false,
              expandDefaultServerVariables: false,
              maxDisplayedEnumValues: 5,
              showObjectSchemaExamples: true,
              showSecuritySchemeType: false,
              unstable_ignoreMimeTypeErrors: false,
            }}
          />
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <Typography variant="body1" color={colors.text_secondary}>
              Loading API documentation...
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ApiDocs;
